import { DetectedWebView, detectWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import { PromiseOnSteroids } from "@ciaopeople/cp-shatsu/PromiseOnSteroids";
import { AuthProviderIdentifier } from "../AuthProviderIdentifier.js";
import { ActualDataTuple, LoginError, LoginErrorCodes, ThirdPartyCientAuthData } from "../data/LoginData.js";
import { debug } from "../LoginDbg.js";
import { LoginProvider, PrompLoginCustomParameters } from "./LoginProvider.js";

import { EmailLoginAskResponse } from "@api-commons/api/RESTUserServices.js";
import { Ask1stPartyEmailAuthData } from "@api-commons/api/types/UserDataTypes.js";
import { Utils } from "@ciaopeople/cp-shatsu/HTTP";
import { LocationDefinition } from "@ciaopeople/cp-shatsu/HTTP/utils";
import { getFunnelSessionId } from "../FunnelSessionUtils.js";

const INTERNAL_PROVIDER_ID = AuthProviderIdentifier.FIRST_PARTY_EMAIL;


const AUTOLOGIN_PARAM_NAME = "chk";

enum PROMPT_MODE  {
    POPUP = 0,
    REDIRECT = 1
}





function changeUrl(url: string) {
    if (typeof (history.pushState) != "undefined") {
        try {
            var obj = { Title: document.title, Url: url };
            history.pushState(obj, obj.Title, obj.Url);
        }catch(e) {
            debug.write("Epush: " + e);
        }
    } else {
        debug.write("Epush: unavailable");
    }
}




export interface EmailCodeChallengePackedData {
    challenge: string,
    code: string,
    purpose?: string
}


// export interface ContextualEmailLoginDialogControls {

    
//     showPersonalModal(): Promise<Ask1stPartyEmailAuthData>
//     askChallenge(data: Ask1stPartyEmailAuthData): Promise<EmailLoginAskResponse>
//     showCodeModal(errorMessage?: string): Promise<string>

// }

export class FirstPartyEmailLogin implements LoginProvider {
    
    private detectedWebview: DetectedWebView;
    
    constructor(public readonly dialogUrl: string, 
        //public readonly enableCodeLoginMode: boolean,
        //public readonly interfaceCmd?: ContextualEmailLoginDialogControls
    ) {
        this.detectedWebview = detectWebView();
    }


    getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData> {
        
        
        const maybeData = FirstPartyEmailLogin.searchForVerificationData();
        
        if(maybeData) {
            return Promise.resolve(maybeData);
        }
        else {
            return Promise.reject(new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "No session available"));
        }
        
    }


    static searchForVerificationData(): ThirdPartyCientAuthData | null{
        const locDef: LocationDefinition = Utils.urlSep(document.location.href);
        const mailcheck: string | null = locDef.params && (AUTOLOGIN_PARAM_NAME in locDef.params)?locDef.params[AUTOLOGIN_PARAM_NAME].trim():null;
        
        if(mailcheck && mailcheck.length > 10) {
            const copiedParams = {...locDef.params};
            delete copiedParams[AUTOLOGIN_PARAM_NAME];
            const newUrl = Utils.urlCombine({
                params: copiedParams,
                url: locDef.url
            });
            changeUrl(newUrl);
            return new ThirdPartyCientAuthData(null,
                    new ActualDataTuple(INTERNAL_PROVIDER_ID, mailcheck));
        }
        else {
            return null;
        }
    }


    getHintInQueryString(): string | null {
        const searchParams = new URLSearchParams(window.location.search);
        const hint = searchParams.get("_sh");
        return hint != ""?hint:null;
    }


    static marshallTPUD(askResponse: EmailLoginAskResponse, code: string): ThirdPartyCientAuthData | null {
        const obj = {
                challenge: askResponse.challenge,
                purpose: askResponse.purpose,
                code: code
            };
            const tpud: ThirdPartyCientAuthData = {
                actualData: {
                    providerId: INTERNAL_PROVIDER_ID,
                    id_token: JSON.stringify(obj)
                },
                intermediateData: null
            };

        return tpud;
    }

    async promptLogin(customDetails: PrompLoginCustomParameters): Promise<ThirdPartyCientAuthData> {



        // if(this.enableCodeLoginMode && this.interfaceCmd) {
        //     let userData: Ask1stPartyEmailAuthData = null;
        //     if(customDetails && customDetails.email && customDetails.email.trim() != "") {
        //         userData = {
        //             email: customDetails.email.trim()
        //         }
        //     }
        //     else {
        //         userData = await this.interfaceCmd.showPersonalModal();
        //     }

        //     const askResponse = await this.interfaceCmd.askChallenge(userData);
        //     const code = await this.interfaceCmd.showCodeModal(customDetails?.errorMessage);
        //     const tpud = FirstPartyEmailLogin.marshallTPUD(askResponse, code);

        //     return tpud;

        // }
        // else {
            //old popup | redirect mode
            const useMode = this.detectedWebview.browser.webview &&
                                this.detectedWebview.extra.isFacebook?PROMPT_MODE.REDIRECT:PROMPT_MODE.POPUP;
            const isModePopup = this.detectedWebview.browser.webview && this.detectedWebview.extra.isFacebook ? false : true;

            const returnUri = customDetails && customDetails.returnUri ? customDetails.returnUri : null;
            
            const hint = this.getHintInQueryString();


            const extraParams = {viz: useMode == PROMPT_MODE.POPUP?"popup":"redirect"};
            if(returnUri) extraParams['returnUri'] = returnUri;
            if(hint) extraParams["_sh"] = hint;
            const rawSessionFunnel = getFunnelSessionId();
            if(rawSessionFunnel && rawSessionFunnel.trim() != "") {
                extraParams['propg_sesfun'] = encodeURIComponent(rawSessionFunnel);
            }
            
            const useUrl = Utils.addParamsToUrl(this.dialogUrl,extraParams);
            

            if(isModePopup) {
                const width = 680;
                const height = 760;
                const left = Math.floor((screen.width - width) / 2);
                const top = Math.floor((screen.height - height) / 2);
                const windowSettings: string[][] = [
                    ["width", width +""],
                    ["height", height + ""],
                    ["screenY", top + ""],
                    ["screenX", left + ""],
                    ["location", '0'],
                    ["menubar", '0'],
                    ["toolbar", '0']
                ];

                const serializedSettings = windowSettings.
                    map(kv => kv.join("=")).join(",");
                
                const popupWindow: Window = window.open(useUrl, 'emailLogin', serializedSettings);
                if(popupWindow) {
                    /**
                     * @note Temporaneamente commentato 
                     * Commentato in quanto ad oggi gli altri provider non rejectano la promise in chiusura della finestra
                     * Questa cosa, seppur errata, comporterebbe di dover fare dei cambi che ora non abbiamo il tempo di fare.
                     * Non possiamo rejectare la promise perchè il login manager nei vari listener converte i reject in 
                     * in resolve(NoSessionChange). Questa cosa non è stata gestita correttamente in alcuni punti (come ad esempio
                     * su showLoginDialog di ClientSdk7) ed in questo momento non vogliamo rischiare regressioni
                     */ 
                    // return PromiseOnSteroids.windowClosePromise(popupWindow).then(x => {
                    //     return Promise.reject(new LoginError(LoginErrorCodes.WAITING_USER_ACTION,"Waiting for user action"));    
                    // });
                    return new Promise(() => {});
                }
                else {
                    debug.write("Cannot open Login popup -- maybe popups are blocked");
                    return Promise.reject(new LoginError(LoginErrorCodes.UNSPECIFIED_ERROR, "Popups are blocked"));
                }
                
            }
            else {
                window.location.href = useUrl;
                return PromiseOnSteroids.timeout(3000, null);
            }
        //}
    }
    oneTapLogin(): Promise<ThirdPartyCientAuthData> {
        return Promise.reject(new LoginError(0, "Unsupported function with Email Login"));
    }
    preloadAction(): Promise<void> {
        return Promise.resolve();
    }
    eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        return Promise.resolve(true);
    }
    niceName: string = "Email";
    supportsAutoLogin: boolean = false;
    useOwnLoginPrompt: boolean = true;
    providerId: AuthProviderIdentifier = INTERNAL_PROVIDER_ID;
    supportsOneTap: boolean = false;
    
}